export default {"src":"/_next/static/media/FR.69cccac6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};